webpackJsonp([36829835628245],{

/***/ 25:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer(_ref) {
	  var siteTitle = _ref.siteTitle;
	  return _react2.default.createElement(
	    'div',
	    { className: 'Footer' },
	    _react2.default.createElement(
	      'svg',
	      { width: '100%', height: '172', viewBox: '0 0 100% 172', fill: 'none' },
	      _react2.default.createElement(
	        'path',
	        { fill: '#F5A623' },
	        _react2.default.createElement('animate', { repeatCount: 'indefinite', fill: 'freeze', attributeName: 'd', dur: '10s',
	          values: 'M0 25.9086C277 84.5821 433 65.736 720 25.9086C934.818 -3.9019 1214.06 -5.23669 1442 8.06597C2079 45.2421 2208 63.5007 2560 25.9088V171.91L0 171.91V25.9086Z; M0 86.3149C316 86.315 444 159.155 884 51.1554C1324 -56.8446 1320.29 34.1214 1538 70.4063C1814 116.407 2156 188.408 2560 86.315V232.317L0 232.316V86.3149Z; M0 53.6584C158 11.0001 213 0 363 0C513 0 855.555 115.001 1154 115.001C1440 115.001 1626 -38.0004 2560 53.6585V199.66L0 199.66V53.6584Z; M0 25.9086C277 84.5821 433 65.736 720 25.9086C934.818 -3.9019 1214.06 -5.23669 1442 8.06597C2079 45.2421 2208 63.5007 2560 25.9088V171.91L0 171.91V25.9086Z;' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'footerSecond' },
	      _react2.default.createElement(
	        'div',
	        { className: 'footerGrid' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Irina Koepp'
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            'MutterKindPflege'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: '/imprint' },
	            'Impressum'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: '/datenschutz' },
	            'Datenschutz'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _footer = __webpack_require__(22);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Imprint = function Imprint() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'Imprint' },
	    _react2.default.createElement(
	      'div',
	      { className: 'ImprintInner' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Impressum'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Diensteanbieter'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Irina Koepp',
	        _react2.default.createElement('br', null),
	        'MutterKindPflege',
	        _react2.default.createElement('br', null),
	        'Maximilianstr. 12',
	        _react2.default.createElement('br', null),
	        'Deutschland',
	        _react2.default.createElement('br', null),
	        'Institutionskennzeichen (IK): 463101872'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Kontaktm\xF6glichkeiten'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'E-Mail-Adresse: ',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:info@mutterkindpflege.berlin' },
	          'info@mutterkindpflege.berlin'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Telefon: +49 176 72469682'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Berufshaftpflichtversicherung'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'AXA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Versicherung AG'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Postfach 92 03 01'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '51153 K\xF6ln'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'R\xE4umliche Geltung: Deutschland'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Haftungs- und Urheberrechtshinweise'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Links auf fremde Webseiten: Inhalte fremder Webseiten, auf die wir direkt oder indirekt verweisen, liegen au\xDFerhalb meines Verantwortungsbereiches und mache ich mir nicht zu Eigen. F\xFCr alle Inhalte und insbesondere f\xFCr Sch\xE4den, die aus der Nutzung der in den verlinkten Webseiten aufrufbaren Informationen entstehen, haftet allein der Anbieter der verlinkten Webseiten.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Bildnachweise'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Bildquellen und Urheberrechtshinweise:',
	        _react2.default.createElement('br', null),
	        '\xA9Felix Koepp'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Design & Implementierung:'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'http://felix-koepp.com' },
	        'felix-koepp.com'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'ImprintEnd' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Zur\xFCck zur Website'
	        ),
	        _react2.default.createElement('br', null)
	      )
	    ),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	exports.default = Imprint;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-imprint-js-d137ac75980d4929bd80.js